import React, { createContext, useState } from 'react';

export const FlagContext = createContext();